function Divider() {
  return <div className="custom-divider"></div>;
}
export default Divider;
